import { WhoAmI } from 'containers/Auth_old/selectors';

export const canViewConversations = (whoami?: WhoAmI | null): boolean =>
  whoami?.cai_conversation_log_enabled === true &&
  whoami.policies?.view_reports === true;
